export default `---
slug: poland
country: Poland
countryCode: POL
continent: Europe
year: 2018
title: "Poland"
description: "Kraków, pierogi, and history at every corner."
thumbnail: /images/travels/POL/poland_thumb.jpg
relatedLinks: []
---
![poland](/images/travels/POL/poland_thumb.jpg)

*Story coming soon — stay tuned!*

I visited Poland and it was an incredible experience. Full story and photos are being written up and will appear here soon.
`;
